var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.isVisible)?_c('div',{staticClass:"toast-container",class:_vm.type},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }